export default __webpack_public_path__ + "static/media/mrotimsig.0a21d26d.png";